import SvgIcon from '~/components/SvgIcon';
import {
    iconCreators,
    iconDarkMode,
    iconLanguge,
    iconLogout,
    iconProfile,
    iconQuestion,
    iconSetting,
    iconTiktokCoin,
    iconTiktokLive,
} from '~/components/SvgIcon/iconsRepo';

export const PUBLIC_MENU = [
    {
        icon: <SvgIcon icon={iconCreators} />,
        title: '创作者工具',
    },
    {
        icon: <SvgIcon icon={iconLanguge} />,
        title: '简体中文',
        children: {
            title: '语言',
            data: [
                {
                    title: 'Tiếng Việt (Việt Nam)',
                },
                {
                    title: 'English',
                },
                {
                    title: 'العربية',
                },
                {
                    title: 'বাঙ্গালি (ভারত)',
                },
                {
                    title: 'Cebuano (Pilipinas)',
                },
                {
                    title: 'Čeština (Česká republika)',
                },
                {
                    title: 'Deutsch',
                },
                {
                    title: 'Ελληνικά (Ελλάδα)',
                },
                {
                    title: 'Español',
                },
                {
                    title: 'Suomi (Suomi)',
                },
                {
                    title: 'Filipino (Pilipinas)',
                },
                {
                    title: 'Français',
                },
                {
                    title: 'हिंदी',
                },
                {
                    title: 'Magyar (Magyarország)',
                },
                {
                    title: 'Bahasa Indonesia (Indonesia)',
                },
                {
                    title: 'Italiano (Italia)',
                },
                {
                    title: '日本語（日本）',
                },
                {
                    title: 'Basa Jawa (Indonesia)',
                },
                {
                    title: 'ខ្មែរ (កម្ពុជា)',
                },
                {
                    title: '한국어 (대한민국)',
                },
                {
                    title: 'Bahasa Melayu (Malaysia)',
                },
                {
                    title: 'မြန်မာ (မြန်မာ)',
                },
                {
                    title: 'Nederlands (Nederland)',
                },
                {
                    title: 'Polski (Polska)',
                },
                {
                    title: 'Português (Brasil)',
                },
                {
                    title: 'Română (Romania)',
                },
                {
                    title: 'Русский (Россия)',
                },
                {
                    title: 'Svenska (Sverige)',
                },
                {
                    title: 'ไทย (ไทย)',
                },
                {
                    title: 'Türkçe (Türkiye)',
                },
                {
                    title: 'Українська (Україна)',
                },
                {
                    title: 'اردو',
                },
                {
                    title: '简体中文',
                },
                {
                    title: '繁體中文',
                },
            ],
        },
    },
    {
        icon: <SvgIcon icon={iconQuestion} />,
        title: '反馈与帮助',
        // to: '/feedback',
    },
    {
        icon: <SvgIcon icon={iconDarkMode} />,
        title: '深色模式',
        children: {
            title: '深色模式',
            data: [
                {
                    title: '跟随设备',
                },
                {
                    title: '深色模式',
                },
                {
                    title: '浅色模式',
                },
            ],
        },
    },
];

export const PRIVATE_MENU = [
    {
        icon: <SvgIcon icon={iconProfile} />,
        title: '查看个人主页',
    },
    {
        icon: <SvgIcon icon={iconTiktokCoin} />,
        title: '获取金币',
    },
    {
        icon: <SvgIcon icon={iconTiktokLive} />,
        title: 'LIVE 工作室',
    },
    {
        icon: <SvgIcon icon={iconSetting} />,
        title: '设置',
    },

    ...PUBLIC_MENU,

    {
        icon: <SvgIcon icon={iconLogout} />,
        title: '退出登录',
        separate: true,
    },
];
